import { Fragment } from 'react';

import map from 'lodash/map';
import times from 'lodash/times';

import { BudgetStatusBadge } from '@sbv-clients/domain-ui-shared';
import {
  styled,
  Table as BaseTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  theme,
} from '@sbv-clients/ui-shared';
import { addDays, formatDate, toRound } from '@sbv-clients/util-misc';

import { UnderOverPositionType } from '../../../services/dashboard';

const TABLE_BORDER_COLOR = theme.colors.border.tableLight;

const Table = styled(BaseTable)`
  & .MuiTableCell-root {
    border: 1px solid ${TABLE_BORDER_COLOR};
  }
`;

type OverUnderTableType = {
  startDate: string;
  data: UnderOverPositionType[];
};

const OverUnderTable = ({ startDate, data }: OverUnderTableType) => {
  return (
    <TableContainer>
      <Table size="small" bgcolor="white" sx={{ fontSize: 'smaller' }}>
        <TableHead>
          <TableRow>
            <TableCell></TableCell>
            {times(7, (index) => (
              <TableCell key={index} colSpan={2} align="center">
                {formatDate(addDays(new Date(startDate), index), 'MMM dd')}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell align="center">Position</TableCell>
            {times(7, (index) => (
              <Fragment key={index}>
                <TableCell align="center" colSpan={1}>
                  Ppl
                </TableCell>
                <TableCell align="center" colSpan={1}>
                  Hrs
                </TableCell>
              </Fragment>
            ))}
          </TableRow>
          {map(data, (item, i) => (
            <TableRow key={i}>
              <TableCell align="center">{item.positionName}</TableCell>
              {map(item.dates, (date, i) => (
                <Fragment key={i}>
                  <TableCell
                    align="center"
                    colSpan={1}
                    sx={{
                      px: 1,
                    }}
                  >
                    <BudgetStatusBadge
                      budgetStatus={date.aggregateBudgetStatus}
                      decimals={1}
                    />
                  </TableCell>
                  <TableCell
                    align="center"
                    colSpan={1}
                    // sx={{
                    //   backgroundColor:
                    //     OverVsUnderBorderColor[date.overUnder as number],
                    // }}
                  >
                    {toRound(date.hours || 0, 1)}
                  </TableCell>
                </Fragment>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
export default OverUnderTable;
